<template>
  <div id="device-mana">
    <div class="radio-box">
      <el-radio-group
        v-model="radio1"
        @change="changeTab"
      >
        <el-radio-button label="已安装设备"></el-radio-button>
        <el-radio-button label="未安装设备"></el-radio-button>
      </el-radio-group>
    </div>
    <router-view />
  </div>
</template>

<script>
// import { createNamespacedHelpers, mapState } from 'vuex'

// const { mapActions } = createNamespacedHelpers('ManaModeStore')

export default {
  name: 'DeviceMana',
  data () {
    return {
      radio1: '已安装设备',
      tab: {
        '已安装设备': 'installDevice',
        '未安装设备': 'notInstallDevice',
      },
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    changeTab (e) {
      // console.log(e)
      this.$router.push({ name: this.tab[e] })
    },
  },
}
</script>

<style lang="less" scoped>
#device-mana {
  width: 100%;
  min-height: 790px;
  // padding-top: 20px;
  background-color: #fff;
  border: 1px solid #EBEEF0;
  >div {
    width: 95%;
    margin: 0 auto;
  }
  .radio-box {
    margin-top: 20px;
  }
}
</style>
